export const engagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId =
  "/engagement/feature_flag_rollouts_data/:feature_flag_bson_id/:app_group_id";
